<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Networks from './networks'
import Multiselect from 'vue-multiselect'

import axios from 'axios'

export default {
	components: { Multiselect },
  props: {
    title: {
      type: String,
      required: true
    },
	  operation: {
	    type: String,
      required: true
    },
    network: {
      type: Object,
      default: function() { return {
        id: null,
        company: null,
        vlan: null,
        location: null,
        network: null,
        tags: []
      }}
    },
  },
	data() {
		return {
			category: 'List',
      newTag: null,
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All networks',
					active: true,
				},
			],
      tagsOptions: [
          "Dangerous",
          "In review",
          "Changed",
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
    }
	},
	methods: {
	  createNewnetwork () {
      let that = this

      that.network.company = that.network.company.toUpperCase()
      that.network.company = that.network.company.trim()
      that.network.location = that.network.location.toUpperCase() 
      that.network.location = that.network.location.trim() 
      that.network.vlan = that.network.vlan.toUpperCase()
      that.network.vlan = that.network.vlan.trim()
      that.network.network = that.network.network.trim()

      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios.post(`${baseURL}/data/networks/${that.operation}`, that.network).then(response => {
        that.$root.$emit('networkCreatedOk')
      }).catch(e => {
        console.log(e);
      });
    },
    newnetwork () {
      this.$refs['modal-new-network'].show()
    },
    showModal () {
      const that = this
      that.$nextTick(() => {
        that.$refs['modal-new-network'].show()
      })
      // this.$refs['modal-new-network'].show()
    },
    addNewTag() {
      this.network.tags.push(this.newTag)
      this.tagsOptions.push(this.newTag)
    },
	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
  <div>
  <b-modal
      ref="modal-new-network"
      size="xl"
      :title="title"
      :centered=true
      :no-fade=true
      @ok="createNewnetwork"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-12 col-sm-12">
                <div class="form-group mt-3 mt-sm-0">
                  <label for="default">Company</label>
                  <b-form-input id="input-1" v-model="network.company" placeholder="" trim></b-form-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-sm-12">
                <div class="form-group mt-3 mt-sm-0">
                  <label for="default">Location</label>
                  <b-form-input id="input-1" v-model="network.location" placeholder="" trim></b-form-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-sm-12">
                <div class="form-group mt-3 mt-sm-0">
                  <label for="default">VLAN</label>
                  <b-form-input id="input-1" v-model="network.vlan" placeholder="" trim></b-form-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-sm-12">
                <div class="form-group mt-3 mt-sm-0">
                  <label for="default">Network</label>
                  <b-form-input id="input-1" v-model="network.network" placeholder="Please use a CIDR format" trim></b-form-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-sm-6">
                <div class="form-group mt-3 mt-sm-0">
                  <label for="default">Tags</label>
                  <multiselect
                      v-model="network.tags"
                      :options="tagsOptions"
                      :multiple="true"
                  ></multiselect>
                </div>
              </div>
              <div class="col-xl-6 col-sm-6">
                <div class="form-group mt-3 mt-sm-0">
                  <label for="default">New Tag</label>
                  <div class="col-xl-12 col-sm-12">
                  <div class="form-inline" style="width:100%">
                  <b-form-input
                      v-model="newTag"
                      id="input-horizontal"
                  ></b-form-input>
                    &nbsp;
                    <button
                      type="submit"
                      class="btn btn-primary"
                      @click="addNewTag"
                    >Add</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
  </div>
</template>
